module.exports = __webpack_public_path__ + "img/planular-landingpage.1e25e0b6.png";